export type RecentSearchType = {
  query: string;
  timestamp: number;
};

export enum EventType {
  SearchResult = "Search Result",
  SearchResultTap = "Search Result Tap",
}

export type SearchInputSource =
  | "search-bar"
  | "trending-search"
  | "recent-search";

export type CourseHit = {
  __position: number;
  record_id: number;
  title: string;
  maestro: {
    full_name: string;
  };
};

export type LessonHit = {
  __position: number;
  record_id: number;
  title: string;
  maestro: {
    full_name: string;
  };
  lesson: {
    id: number;
    title: string;
  };
};

export type SearchAnalyticsHelperOptions = {
  getQuery: () => string;
  courseHits?: Map<number, Record<string, unknown>>;
  lessonHits?: Map<number, Record<string, unknown>>;
  getHitCounts: () => {
    num_hits_courses: number;
    num_hits_lessons?: number;
  };
};

type BaseConfig = {
  apiKey: string;
  nearestNodeHost: string;
  nodesHosts: string[];
};

type CourseConfig = {
  courseIndexName: string;
  coursePresetName: string;
};

type LessonConfig = {
  lessonIndexName: string;
  lessonPresetName: string;
};

export type TypesenseConfig = BaseConfig & CourseConfig & Partial<LessonConfig>;

export type TypesenseServiceOptions = {
  config: TypesenseConfig;
  includeLessonIndex?: boolean;
  initialUiState?: Record<string, Record<string, unknown>>;
  onStateChange?: (params: {
    uiState: Record<string, Record<string, unknown>>;
    setUiState: (uiState: Record<string, Record<string, unknown>>) => void;
  }) => void;
};
